// @ commons
const { APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');

// @utilities
const moment = require('moment');
const { formatText } = require('core/i18n').i18n;
const { cloneDeep } = require('lodash');
const { getEstatesToRequest } = require('utilities/mortgageHelper');

// @ constants
const {
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_VALIDATE_STEP,
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_WILL_CANCEL,
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_SET_ACCOUNT,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_REQUEST,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_SUCCESS,
    MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_FAILURE,
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_SET_TOTAL_COST,
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_CLEAR
} = require('constants/actionTypes');
const { SECOND_STEP, DATE_FORMAT_API, EURO_TEXT, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const {
    PAYMENT_TYPE,
    TRANSFER_TYPE,
    TRANSFER_COUNTRY,
    RECIPIENT_INDICATOR,
    BENEFICIARY_BANK_NAME,
    BENEFICIARY_INDICATOR,
} = require('constants/transferData').TRANSFER_INFORMATION;

const setVisibleStep = step => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_SET_VISIBLE_STEP,
    data: {
        step
    }
});

const validateWithUI = step => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_VALIDATE_STEP,
    data: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_WILL_CANCEL,
    data: {
        willCancel
    }
});

const setAccount = (accountId, accountBalance, accountIBAN) => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_SET_ACCOUNT,
    data: {
        accountId,
        accountBalance,
        accountIBAN
    }
});

const setTotalCost = (totalCost) => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_SET_TOTAL_COST,
    data: {
        totalCost
    }
});

const simpleNoteRequestSignatureInProgress = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_REQUEST
});

const simpleNoteRequestSignatureSuccess = () => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_SUCCESS
});

const simpleNoteRequestSignatureFailure = (error) => ({
    type: MORTGAGE_REQUEST_SIMPLE_NOTE_SIGNATURE_FAILURE,
    data: {
        error
    }
});

const clearRequest = () => ({
    type: MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_CLEAR
});

const processSimpleNote = () => dispatch => {

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestSimpleNote'
    })
        .then(() => {
            dispatch(simpleNoteRequestSignatureSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleNoteRequestSignatureFailure(response.error));
            } else {
                throw response;
            }
        });
}

const confirmPaymentSimpleNote = paymentDataQuery => dispatch => {
    const query = cloneDeep(paymentDataQuery);
    const paymentData = {
        header: {
            version: 2
        },
        query
    };

    return APIPost({
        dispatch,
        endpoint: 'simpleNoteTransferMoneyConfirmation',
        params: paymentData
    })
        .then(response => {
            if (!!response.respuesta) {
                dispatch(processSimpleNote());
            } else {
                dispatch(simpleNoteRequestSignatureFailure(response.error));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleNoteRequestSignatureFailure(response.error));
            } else {
                throw response;
            }
        });
}

const simpleNoteRequestSignature = () => (dispatch, getState) => {
    const {
        mortgageRequestSimpleNoteRequest,
        mortgageRequestSummaryDocumentation
    } = getState();
    const isAlreadyFetching = mortgageRequestSimpleNoteRequest.get('isFetching');

    const callback = (dispatch, getState, dataToken) => {

        dispatch(simpleNoteRequestSignatureInProgress());

        dispatch(setPaymentAccount())

        const { mortgageRequestPayment, accounts, mortgageRequestInmuebles } = getState();
        const immStep = mortgageRequestSimpleNoteRequest.getIn(['steps', SECOND_STEP]);
        const accountId = immStep.get('accountId');
        const immAccount = accounts.getIn(['byId', accountId]);
        const contractNumber = immAccount.get('newContractNumber');
        const product = immAccount.get('newProduct');
        const paymentAccount = mortgageRequestPayment.get('paymentAccount').replace(/\s/g, '');
        const beneficiaryName = formatText("mortgageRequestSimpleNoteRequest-beneficiaryName");
        const date = moment().format(DATE_FORMAT_API);
        const originAccount = `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`;
        const estatesToRequest = getEstatesToRequest(
            mortgageRequestInmuebles,
            mortgageRequestSummaryDocumentation
        );
        const paymentImport = mortgageRequestPayment.get('simpleNoteCost') * estatesToRequest.length;

        const postData = {
            header: {
                version: 2
            },
            query: {
                contratoOrdenante: {
                    numeroContrato: contractNumber,
                    producto: product
                },
                cuentaBeneficiario: paymentAccount,
                divisaOrd: EURO_TEXT,
                importe: {
                    divisa: EURO_TEXT,
                    importe: paymentImport
                },
                fechaEmision: date,
                indicadorResidenciaDestinatario: RECIPIENT_INDICATOR,
                nombreCompletoBeneficiario: beneficiaryName,
                tipoTransferencia: TRANSFER_TYPE,
                paisTransferencia: TRANSFER_COUNTRY,
                contratoOrdenanteIban: originAccount
            }
        }

        return APIPost({
            dispatch,
            endpoint: 'transferMoneyValidation',
            params: postData
        })
            .then(response => {
                const { tipoSepa, actuanteBeneficiario } = response;
                const validationParams = cloneDeep(postData.query);

                const {
                    contratoOrdenante,
                    cuentaBeneficiario: cuentaIbanBeneficiario,
                    fechaEmision,
                    importe,
                    nombreCompletoBeneficiario,
                    tipoTransferencia
                } = validationParams;

                const paymentData = {
                    tipoSepa,
                    actuanteBeneficiario,
                    contratoOrdenante: {
                        numerodecontrato: contratoOrdenante.numeroContrato,
                        producto: contratoOrdenante.producto
                    },
                    cuentaIbanBeneficiario,
                    dataToken,
                    fechaEmision,
                    importe,
                    indResidenteBeneficiario: BENEFICIARY_INDICATOR,
                    nombreBancoIbanBeneficiario: BENEFICIARY_BANK_NAME,
                    nombreCompletoBeneficiario,
                    tipoTransferencia
                }

                dispatch(confirmPaymentSimpleNote(paymentData));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleNoteRequestSignatureFailure(response.error));
                } else {
                    throw response;
                }
            });
    };

    if (!isAlreadyFetching) {
        new Promise(() => {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback)
        });
    }
};

const setPaymentAccount = () => (dispatch, getState) => {
    const {
        mortgageRequestInmuebles,
        mortgageRequestPayment,
        mortgageRequestSimpleNoteRequest,
        mortgageRequestSummaryDocumentation
    } = getState();
    const estatesToRequest = getEstatesToRequest(
        mortgageRequestInmuebles,
        mortgageRequestSummaryDocumentation
    );
    const paymentImport = mortgageRequestPayment.get('simpleNoteCost') * estatesToRequest.length;
    const properties = estatesToRequest.map((estateToRequest) => estateToRequest.bienId);
    const immStep = mortgageRequestSimpleNoteRequest.getIn(['steps', SECOND_STEP]);
    const agencyPaymentAccount = mortgageRequestPayment.get('paymentAccount');
    const clientPaymentAccount = immStep.get('accountIBAN');
    const paymentDate = moment().format(DATE_FORMAT_API);
    const requestData = {
        query: {
            agencyPaymentAccount,
            clientPaymentAccount,
            paymentDate,
            paymentImport,
            paymentReference: '',
            paymentType: PAYMENT_TYPE,
            properties
        }
    }

    return APIPost({
        dispatch,
        endpoint: 'mortgageRequestSimpleNotePayment',
        params: requestData
    })
}

const validateStep = (step) => (dispatch) => {
    dispatch(validateWithUI(step));
}

module.exports = {
    validateStep,
    setVisibleStep,
    setWillCancel,
    setAccount,
    setTotalCost,
    simpleNoteRequestSignature,
    clearRequest
};
